<script setup>
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37">
        <path
            d="M18.5 32.5C18.5 32.5 3.7 23.687 3.7 12.987 3.7 7.548 7.98 3.7 12.617 3.7c3.145 0 5.883 1.73 5.883 4.62 0-2.89 2.738-4.62 5.883-4.62 4.637 0 8.917 3.848 8.917 9.287C33.3 23.687 18.5 32.5 18.5 32.5Z" />
    </svg>
</template>

<style lang="scss" scoped></style>
